webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(91);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  apiKey: 'AIzaSyDCG7KZZBO3YKlq0MF5sZ149jI78aeOt-w',
  authDomain: 'pxlshop-21c30.firebaseapp.com',
  databaseURL: 'https://pxlshop-21c30.firebaseio.com',
  storageBucket: 'pxlshop-21c30.appspot.com',
  messagingSenderId: '1079174567568'
};

var firebaseApp = _firebase2.default.initializeApp(config);

exports.default = {
  firebase: firebaseApp,
  dbRef: firebaseApp.database().ref(),
  dbProductsRef: firebaseApp.database().ref('products'),
  dbUsersRef: firebaseApp.database().ref('users'),
  storageAvatarsRef: firebaseApp.storage().ref('avatars'),
  auth: firebaseApp.auth(),
  googleAuth: new _firebase2.default.auth.GoogleAuthProvider(),
  emailAuth: _firebase2.default.auth.EmailAuthProvider
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(135);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Index = __webpack_require__(119);

var _Index2 = _interopRequireDefault(_Index);

var _Shop = __webpack_require__(121);

var _Shop2 = _interopRequireDefault(_Shop);

var _About = __webpack_require__(115);

var _About2 = _interopRequireDefault(_About);

var _Contacts = __webpack_require__(118);

var _Contacts2 = _interopRequireDefault(_Contacts);

var _Cart = __webpack_require__(116);

var _Cart2 = _interopRequireDefault(_Cart);

var _Checkout = __webpack_require__(117);

var _Checkout2 = _interopRequireDefault(_Checkout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: _Index2.default,
    props: true
  }, {
    path: '/shop',
    name: 'Shop',
    component: _Shop2.default,
    props: true
  }, {
    path: '/about',
    name: 'About',
    component: _About2.default
  }, {
    path: '/contacts',
    name: 'Contacts',
    component: _Contacts2.default
  }, {
    path: '/cart',
    name: 'Cart',
    component: _Cart2.default,
    props: true
  }, {
    path: '/checkout',
    name: 'Checkout',
    component: _Checkout2.default,
    props: true
  }, {
    path: '*',
    component: _Index2.default
  }],
  scrollBehavior: function scrollBehavior(to, from) {
    return { x: 0, y: 0 };
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjU2LjQ4cHgiIGhlaWdodD0iNTYuNDhweCIgdmlld0JveD0iMCAwIDU2LjQ4IDU2LjQ4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1Ni40OCA1Ni40ODsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQoJPg0KPGc+DQoJPHBhdGggZD0iTTMzLjM3MiwyNC44ODhjMC4yMjgsMC4xNSwwLjMzNywwLjM4NSwwLjM0MywwLjY5N2MwLjAwMiwwLjQ3OS0wLjE3NiwwLjg0My0wLjUyNiwxLjEwNA0KCQljLTAuMzU0LDAuMjU0LTAuODQ1LDAuMzg0LTEuNDc4LDAuMzg0SDMxLjQyYy0wLjI1MywwLjAwMi0wLjQxNi0wLjIwMi0wLjM1OS0wLjQ0NmwwLjM1NC0xLjUxOQ0KCQljMC4wNTItMC4yNDMsMC4zMDgtMC40NDcsMC41Ni0wLjQ0NWwwLjM4MS0wLjAwMkMzMi44MDUsMjQuNjYzLDMzLjE0MSwyNC43MzgsMzMuMzcyLDI0Ljg4OHogTTE3LjUwNSwyOC40Ng0KCQljLTAuMywwLjA0My0wLjU2LDAuMTAzLTAuNzcxLDAuMTc0bC0wLjQ5NiwwLjMzOGMtMC4xMTYsMC4xNDYtMC4xNzEsMC4zMzItMC4xNzEsMC41NzFsMC4yMjYsMC40MzgNCgkJYzAuMTUzLDAuMDg2LDAuMzc5LDAuMTI4LDAuNjY3LDAuMTI4YzAuMTksMCwwLjM5Ni0wLjA0NiwwLjYxMi0wLjEzNGwwLjQ2LTAuMjM3bDAuMTgyLTAuMjQyYzAuMDcyLTAuMjgyLDAuMjIxLTAuOTA5LDAuMjM4LTAuOTg3DQoJCWwtMC4wODEtMC4xNDRDMTguMzAyLDI4LjM2NywxNy43NzMsMjguNDI3LDE3LjUwNSwyOC40NnogTTM4Ljc2OCwyOC40NjZjLTAuMzAzLDAuMDQzLTAuNTYyLDAuMTAyLTAuNzcxLDAuMTc0DQoJCWMtMC4yMTQsMC4wODQtMC4zODgsMC4xOTctMC41MDEsMC4zMzhjLTAuMTEyLDAuMTQ2LTAuMTY4LDAuMzMyLTAuMTY4LDAuNTcybDAuMjI5LDAuNDM3YzAuMTQ2LDAuMDg3LDAuMzY5LDAuMTI5LDAuNjY2LDAuMTI5DQoJCWMwLjE4NywwLDAuMzkzLTAuMDQ2LDAuNjA4LTAuMTMzbDAuNDU3LTAuMjM3bDAuMTg4LTAuMjQyYzAuMDctMC4yODUsMC4yMjItMC45MSwwLjIzNC0wLjk4OGwtMC4wODItMC4xNDUNCgkJQzM5LjU1OSwyOC4zNzEsMzkuMDMyLDI4LjQzMywzOC43NjgsMjguNDY2eiBNMTEuMTAzLDI0LjYzNWwtMC4zODMsMC4wMDJjLTAuMjUxLTAuMDAyLTAuNTA4LDAuMi0wLjU1NywwLjQ0NGwtMC4zNTMsMS41Mg0KCQljLTAuMDU1LDAuMjQ2LDAuMTAyLDAuNDQ3LDAuMzU2LDAuNDQ3aDAuMjg2YzAuNjM1LDAsMS4xMjctMC4xMjksMS40OC0wLjM4OWMwLjM1My0wLjI1OCwwLjUzNC0wLjYyNSwwLjUyNi0xLjENCgkJYzAuMDAyLTAuMzEzLTAuMTExLTAuNTQ5LTAuMzM3LTAuNjk4QzExLjg5MiwyNC43MTIsMTEuNTUxLDI0LjYzNSwxMS4xMDMsMjQuNjM1eiBNNTYuNDgsMTEuMzkzdjMzLjY5NQ0KCQljMCwwLjgwMy0wLjY1LDEuNDU0LTEuNDU0LDEuNDU0SDEuNDU0QzAuNjUsNDYuNTQyLDAsNDUuODksMCw0NS4wODdWMTEuMzkzYzAtMC44MDMsMC42NS0xLjQ1NCwxLjQ1NC0xLjQ1NGg1My41NzINCgkJQzU1LjgzLDkuOTM5LDU2LjQ4LDEwLjU5LDU2LjQ4LDExLjM5M3ogTTE0LjY4MSwyNS4zNzRjMC0wLjQyLTAuMDY5LTAuNzczLTAuMjI1LTEuMDU1Yy0wLjE0LTAuMjgyLTAuMzYzLTAuNTE1LTAuNjM5LTAuNjg5DQoJCWMtMC4yODgtMC4xNzYtMC42MjgtMC4zLTEuMDE4LTAuMzc0Yy0wLjM5Ni0wLjA3Mi0wLjg1My0wLjEwNC0xLjM4MS0wLjEwOWwtMi40NDQsMC4wMDFjLTAuMjU0LDAuMDA0LTAuNTAzLDAuMjAxLTAuNTYzLDAuNDQ3DQoJCWwtMS42NDUsNy4xNjNDNi43MDYsMzEsNi44NjUsMzEuMjA0LDcuMTE5LDMxLjIwNGgxLjE3YzAuMjU0LDAsMC41MDUtMC4xOTgsMC41NjItMC40NDZsMC40MDItMS43MzgNCgkJYzAuMDUzLTAuMjQyLDAuMzA0LTAuNDQ0LDAuNTYxLTAuNDQ0aDAuMzM0YzEuNDMyLTAuMDAyLDIuNTQtMC4yOTQsMy4zMzYtMC44OEMxNC4yODYsMjcuMTA5LDE0LjY4MSwyNi4zMzMsMTQuNjgxLDI1LjM3NHoNCgkJIE0yMC43NjcsMjYuNWMwLjAwMi0wLjUyMS0wLjIyNC0wLjkwOS0wLjY2Ny0xLjE1N2MtMC40NDEtMC4yNDktMS4xMzktMC4zNzMtMi4wOTItMC4zNzNjLTAuNDcxLDAtMC45NDEsMC4wMzctMS40MTYsMC4xMQ0KCQljLTAuMzUxLDAuMDU0LTAuMzg1LDAuMDYzLTAuNiwwLjExMWMtMC40NDUsMC4wOTctMC41MTUsMC41NDItMC41MTUsMC41NDJsLTAuMTQzLDAuNTg5Yy0wLjA4MSwwLjM3NiwwLjEzNiwwLjM2MSwwLjIyNiwwLjMzDQoJCWMwLjE5NC0wLjA1OCwwLjMwMy0wLjExNywwLjctMC4yMDdjMC4zNzktMC4wODYsMC43NzktMC4xNTEsMS4wOTctMC4xNDdjMC40NjgsMCwwLjgyNiwwLjA1LDEuMDY0LDAuMTUNCgkJYzAuMjM1LDAuMTAzLDAuMzUzLDAuMjc4LDAuMzUzLDAuNTMybC0wLjAyMSwwLjE2NWwtMC4xNjgsMC4xMDRjLTAuNjY1LDAuMDQyLTEuMTQ1LDAuMTAzLTEuNzI3LDAuMTg3DQoJCWMtMC41NywwLjA3OS0xLjA2OSwwLjIxOS0xLjQ4NCwwLjQwOGMtMC40NDYsMC4xOTYtMC43NzYsMC40NTgtMS4wMDcsMC43OTRjLTAuMjIzLDAuMzM4LTAuMzM0LDAuNzQ0LTAuMzM0LDEuMjI0DQoJCWMwLDAuNDUyLDAuMTYyLDAuODIxLDAuNDc2LDEuMTFjMC4zMTYsMC4yODMsMC43MzQsMC40MiwxLjIzMywwLjQyYzAuMzE2LDAsMC41NjEtMC4wMjUsMC43MzUtMC4wNjdsMC41NjYtMC4xOTRsMC40OC0wLjI2OA0KCQlsMC40NDEtMC4yOTFsMC4wMDYsMC4wMDdsLTAuMDQ0LDAuMTg4bC0wLjAwMiwwLjAwN3YwLjAwMmMtMC4wNDgsMC4yMjgsMC4wOSwwLjQxNywwLjMxMywwLjQzOGwwLjAwNCwwLjAwNGgwLjAyMWgwLjg5OGgwLjE2OQ0KCQlsMC4wMTYtMC4wMDZjMC4yMzMtMC4wMjcsMC40NTMtMC4yMTYsMC41MDMtMC40MzhsMC44NTQtMy42OTJsMC4wNDQtMC4zMDFMMjAuNzY3LDI2LjV6IE0yMy4zNTksMzMuNjEybDQuNjY0LTcuODg3DQoJCWMwLDAsMC40NDgtMC42NzQsMC4wMzItMC42NjhjLTAuMjc3LDAuMDAzLTEuNDA0LDAtMS40MDQsMGMtMC4yNTIsMC0wLjU3NiwwLjIwNS0wLjczNiwwLjQ0N2MwLDAtMS42NzYsMi44NzYtMS44MzksMy4xNjUNCgkJbC0wLjE5NC0wLjAwMmwtMC41MjItMy4xNDNjLTAuMDU4LTAuMjQ4LTAuMzE2LTAuNDU5LTAuNjM3LTAuNDU5bC0xLjA0OSwwLjAwMmMtMC4yNTIsMC0wLjQwOCwwLjIwMS0wLjM1LDAuNDQ2DQoJCWMwLDAsMC43OTYsNC41MzIsMC45NTYsNS41OThjMC4wNzQsMC41OS0wLjAwOSwwLjY5My0wLjAwOSwwLjY5M2wtMS4wMzcsMS44MDhjLTAuMTU0LDAuMjQ2LTAuMDcxLDAuNDQ2LDAuMTgxLDAuNDQ2bDEuMjEyLTAuMDAyDQoJCUMyMi44NzcsMzQuMDU2LDIzLjIwOSwzMy44NTgsMjMuMzU5LDMzLjYxMnogTTM1LjkzNiwyNS40Yy0wLjAwMi0wLjQyLTAuMDc1LTAuNzc0LTAuMjI1LTEuMDU0DQoJCWMtMC4xNDYtMC4yODQtMC4zNjUtMC41MTMtMC42NDQtMC42OTJjLTAuMjg0LTAuMTc3LTAuNjI0LTAuMzAxLTEuMDE5LTAuMzczYy0wLjM4OC0wLjA2OS0wLjg1LTAuMTA2LTEuMzc1LTAuMTA4bC0yLjQ0NywwLjAwMg0KCQljLTAuMjU0LDAuMDA0LTAuNSwwLjIwMi0wLjU2LDAuNDQ1bC0xLjY0Niw3LjE2N2MtMC4wNiwwLjI0MywwLjEwNCwwLjQ0NSwwLjM1MywwLjQ0NGwxLjE3My0wLjAwMw0KCQljMC4yNDgsMC4wMDMsMC41MDQtMC4xOTcsMC41NjItMC40NGwwLjM5Ni0xLjc0MWMwLjA1OC0wLjI0MiwwLjMxLTAuNDQ3LDAuNTYyLTAuNDQzaDAuMzM0YzEuNDMyLDAsMi41NDUtMC4yOTUsMy4zNDQtMC44NzgNCgkJQzM1LjUzNSwyNy4xMzMsMzUuOTM2LDI2LjM2LDM1LjkzNiwyNS40eiBNNDIuMDI5LDI2LjUwNGMwLTAuNTIxLTAuMjIzLTAuOTA3LTAuNjY5LTEuMTU1Yy0wLjQ0NS0wLjI0OS0xLjE0Mi0wLjM3NS0yLjA5MS0wLjM3NQ0KCQljLTAuNDcxLDAtMC45NDQsMC4wMzctMS40MTYsMC4xMTNjLTAuMzUsMC4wNTEtMC4zODUsMC4wNjItMC42MDIsMC4xMDljLTAuNDQ3LDAuMDk2LTAuNTE0LDAuNTQyLTAuNTE0LDAuNTQybC0wLjE0MywwLjU4OA0KCQljLTAuMDgsMC4zNzYsMC4xMzEsMC4zNTksMC4yMjksMC4zM2MwLjE5My0wLjA1OCwwLjMtMC4xMTUsMC42OTUtMC4yMDdjMC4zNzgtMC4wODUsMC43NzktMC4xNDksMS4wOTktMC4xNDcNCgkJYzAuNDY2LDAsMC44MjQsMC4wNSwxLjA2MiwwLjE1MWMwLjIzOCwwLjEwMiwwLjM1NCwwLjI3OSwwLjM1NCwwLjUzMWwtMC4wMTgsMC4xNjVsLTAuMTY4LDAuMTA2DQoJCWMtMC42NywwLjA0MS0xLjE1LDAuMTAyLTEuNzI4LDAuMTg2Yy0wLjU2NywwLjA4LTEuMDY5LDAuMjE4LTEuNDg3LDAuNDA4Yy0wLjQ0MiwwLjE5OC0wLjc3NywwLjQ1OS0xLjAwNiwwLjc5NQ0KCQljLTAuMjI0LDAuMzM2LTAuMzM1LDAuNzQ0LTAuMzM1LDEuMjIxYzAsMC40NTQsMC4xNjMsMC44MjUsMC40NzksMS4xMTFjMC4zMTgsMC4yODEsMC43MzIsMC40MjMsMS4yMzIsMC40MjMNCgkJYzAuMzEzLTAuMDA1LDAuNTU5LTAuMDI0LDAuNzMzLTAuMDY5bDAuNTY1LTAuMTkxbDAuNDgzLTAuMjY3bDAuNDM4LTAuMjk1bDAuMDA3LDAuMDA5bC0wLjAzOSwwLjE4OGwtMC4wMDUsMC4wMDRsMC4wMDIsMC4wMDMNCgkJYy0wLjA1NSwwLjIyOSwwLjA4NSwwLjQxNywwLjMxMiwwLjQzOGwwLjAwMiwwLjAwNmgwLjAyMWwwLDBjMC4xNDcsMCwwLjY1NywwLDAuODk5LDBoMC4xNjhsMC4wMTYtMC4wMDYNCgkJYzAuMjMtMC4wMjgsMC40NTEtMC4yMTcsMC40OTktMC40NGwwLjg1Ni0zLjY4OWwwLjA0My0wLjMwM0w0Mi4wMjksMjYuNTA0eiBNNDUuNzQ5LDIzLjY3N2MwLjA1NC0wLjI0NC0wLjA5OS0wLjQ0My0wLjM1NC0wLjQ0Mw0KCQloLTEuMDQ3Yy0wLjIxNSwwLTAuNDA5LDAuMTU5LTAuNTA0LDAuMzU1bC0wLjA1OSwwLjA5MWwtMC4wNTIsMC4yMzJsLTEuNDY2LDYuNjYybC0wLjA0NywwLjIwNWwwLjAwMiwwLjAwNQ0KCQljLTAuMDQ5LDAuMjE4LDAuMDg2LDAuMzg1LDAuMjkzLDAuNDE3bDAuMDIsMC4wMjVoMS4wODhjMC4yMTUsMCwwLjQxMy0wLjE2MiwwLjUwNi0wLjM2MmwwLjA1NS0wLjA4NGwxLjU2OC03LjEwMUw0NS43NDksMjMuNjc3eg0KCQkgTTQ3LjgzLDIyLjc0OWgtMC4zOTJ2LTAuMzI1aC0wLjE5M3YwLjMyNWgtMC4xMzJ2MC4xNjJoMC4xMzJ2MC42MDZsMC4wOTEsMC4zbDAuMjY2LDAuMDk1bDAuMTExLTAuMDA5bDAuMTE3LTAuMDIzdi0wLjE3MWgtMC4wMDkNCgkJbC0wLjA3MywwLjAyMmwtMC4wOTgsMC4wMTRsLTAuMTItMC4wMTlsLTAuMDYyLTAuMDZsLTAuMDI3LTAuMDk0bC0wLjAwMy0wLjE0di0wLjUyMWgwLjM5MlYyMi43NDl6IE00OS43MjcsMjMuMTVsLTAuMDktMC4zMTgNCgkJbC0wLjI3Ny0wLjExM2wtMC4yMDUsMC4wNDJsLTAuMjEsMC4xNDFsLTAuMTIyLTAuMTM2bC0wLjE5OC0wLjA0N2wtMC4xODgsMC4wNDJsLTAuMTgyLDAuMTE2VjIyLjc1aC0wLjE4OHYxLjEzOWgwLjE4OHYtMC44NQ0KCQlsMC4xNTktMC4wOTlsMC4xNTctMC4wMzlsMC4xMjksMC4wMjNsMC4wNjQsMC4wNjVsMC4wMjcsMC4xMDlsMC4wMDgsMC4xNDF2MC42NWgwLjE5di0wLjcyOUw0OC45ODcsMjMuMWwtMC4wMDMtMC4wNTZsMC4xNjMtMC4xMDMNCgkJbDAuMTU5LTAuMDQxbDAuMTI3LDAuMDIzbDAuMDY2LDAuMDY1bDAuMDI1LDAuMTFsMC4wMTIsMC4xMzl2MC42NWgwLjE4OVYyMy4xNXoiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiM2NjYiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLDE2QzEyLjU2LDE2Ljg0IDEzLjMxLDE3LjUzIDE0LjIsMThMMTIsMjAuMkw5LjgsMThDMTAuNjksMTcuNTMgMTEuNDUsMTYuODQgMTIsMTZNMTcsMTEuMkEyLDIgMCAwLDAgMTUsMTMuMkEyLDIgMCAwLDAgMTcsMTUuMkEyLDIgMCAwLDAgMTksMTMuMkMxOSwxMi4wOSAxOC4xLDExLjIgMTcsMTEuMk03LDExLjJBMiwyIDAgMCwwIDUsMTMuMkEyLDIgMCAwLDAgNywxNS4yQTIsMiAwIDAsMCA5LDEzLjJDOSwxMi4wOSA4LjEsMTEuMiA3LDExLjJNMTcsOC43QTQsNCAwIDAsMSAyMSwxMi43QTQsNCAwIDAsMSAxNywxNi43QTQsNCAwIDAsMSAxMywxMi43QTQsNCAwIDAsMSAxNyw4LjdNNyw4LjdBNCw0IDAgMCwxIDExLDEyLjdBNCw0IDAgMCwxIDcsMTYuN0E0LDQgMCAwLDEgMywxMi43QTQsNCAwIDAsMSA3LDguN00yLjI0LDFDNCw0LjcgMi43Myw3LjQ2IDEuNTUsMTAuMkMxLjE5LDExIDEsMTEuODMgMSwxMi43QTYsNiAwIDAsMCA3LDE4LjdDNy4yMSwxOC42OSA3LjQyLDE4LjY4IDcuNjMsMTguNjVMMTAuNTksMjEuNjFMMTIsMjNMMTMuNDEsMjEuNjFMMTYuMzcsMTguNjVDMTYuNTgsMTguNjggMTYuNzksMTguNjkgMTcsMTguN0E2LDYgMCAwLDAgMjMsMTIuN0MyMywxMS44MyAyMi44MSwxMSAyMi40NSwxMC4yQzIxLjI3LDcuNDYgMjAsNC43IDIxLjc2LDFDMTkuMTIsMy4wNiAxNS4zNiw0LjY5IDEyLDQuN0M4LjY0LDQuNjkgNC44OCwzLjA2IDIuMjQsMVoiIC8+PC9zdmc+Cg=="

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./avatar.svg": 15,
	"./cart.svg": 24,
	"./delete.svg": 98,
	"./dots.svg": 99,
	"./facebook.svg": 100,
	"./google.svg": 101,
	"./instagram.svg": 102,
	"./lock.svg": 103,
	"./mail.svg": 104,
	"./mastercard.svg": 6,
	"./name.svg": 105,
	"./paypal.svg": 7,
	"./twitter.svg": 106,
	"./visa.svg": 8,
	"./youtube.svg": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE3LDE4QzE1Ljg5LDE4IDE1LDE4Ljg5IDE1LDIwQTIsMiAwIDAsMCAxNywyMkEyLDIgMCAwLDAgMTksMjBDMTksMTguODkgMTguMSwxOCAxNywxOE0xLDJWNEgzTDYuNiwxMS41OUw1LjI0LDE0LjA0QzUuMDksMTQuMzIgNSwxNC42NSA1LDE1QTIsMiAwIDAsMCA3LDE3SDE5VjE1SDcuNDJBMC4yNSwwLjI1IDAgMCwxIDcuMTcsMTQuNzVDNy4xNywxNC43IDcuMTgsMTQuNjYgNy4yLDE0LjYzTDguMSwxM0gxNS41NUMxNi4zLDEzIDE2Ljk2LDEyLjU4IDE3LjMsMTEuOTdMMjAuODgsNS41QzIwLjk1LDUuMzQgMjEsNS4xNyAyMSw1QTEsMSAwIDAsMCAyMCw0SDUuMjFMNC4yNywyTTcsMThDNS44OSwxOCA1LDE4Ljg5IDUsMjBBMiwyIDAgMCwwIDcsMjJBMiwyIDAgMCwwIDksMjBDOSwxOC44OSA4LjEsMTggNywxOFoiIC8+PC9zdmc+"

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(83)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(129),
  /* scopeId */
  "data-v-60a85834",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

var _MainHeader = __webpack_require__(113);

var _MainHeader2 = _interopRequireDefault(_MainHeader);

var _MainFooter = __webpack_require__(112);

var _MainFooter2 = _interopRequireDefault(_MainFooter);

var _Login = __webpack_require__(111);

var _Login2 = _interopRequireDefault(_Login);

var _Profile = __webpack_require__(114);

var _Profile2 = _interopRequireDefault(_Profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    MainHeader: _MainHeader2.default,
    MainFooter: _MainFooter2.default,
    Login: _Login2.default,
    Profile: _Profile2.default
  },
  data: function data() {
    return {
      user: null,
      productsInCart: {}
    };
  },
  created: function created() {
    var _this = this;

    _firebase2.default.auth.onAuthStateChanged(function (user) {
      if (user) {
        _this.user = user;
        _this.getProductsInCart();
      } else {
        _this.user = null;
      }
    });
  },

  methods: {
    getUserGoogle: function getUserGoogle() {
      var _this2 = this;

      _firebase2.default.auth.getRedirectResult().then(function (result) {
        _this2.user = result.user;
      });
    },
    getProductsInCart: function getProductsInCart() {
      var _this3 = this;

      _firebase2.default.dbUsersRef.child(this.user.uid + '/cart/').on('value', function (snapshot) {
        snapshot.forEach(function (productInCart) {
          _this3.$set(_this3.productsInCart, productInCart.key, productInCart.val());
        });
      });
    }
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

var _Notification = __webpack_require__(26);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'login',
  props: ['light'],
  components: {
    Notification: _Notification2.default
  },
  data: function data() {
    return {
      login: false,
      email: '',
      password: '',
      message: ''
    };
  },

  methods: {
    enter: function enter() {
      if (this.login === 'up') {
        this.signUp();
      } else {
        this.signIn();
      }
    },
    signUp: function signUp() {
      var _this = this;

      _firebase2.default.auth.createUserWithEmailAndPassword(this.email, this.password).then(function () {
        return _this.signIn();
      }).catch(function (error) {
        switch (error.code) {
          case 'auth/weak-password':
            _this.message = 'The password should be at least six symbols.';
            break;
          case 'auth/email-already-in-use':
            _this.message = 'There already exists an account with the given email address.';
            break;
          case 'auth/invalid-email':
            _this.message = 'The email address is not valid.';
            break;
          default:
            _this.message = error.code;
        }
      });
    },
    signIn: function signIn() {
      var _this2 = this;

      _firebase2.default.auth.signInWithEmailAndPassword(this.email, this.password).catch(function (error) {
        switch (error.code) {
          case 'auth/user-not-found':
            _this2.message = 'There is no user corresponding to the given email.';
            break;
          case 'auth/wrong-password':
            _this2.message = 'The password is invalid for the given email';
            break;
          case 'auth/invalid-email':
            _this2.message = 'The email address is not valid.';
            break;
          default:
            _this2.message = error.code;
        }
      });
    },
    signInGoogle: function signInGoogle() {
      var provider = _firebase2.default.googleAuth;
      _firebase2.default.auth.signInWithRedirect(provider);
    }
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__(5);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'main-footer',
  props: ['user', 'productsInCart'],
  data: function data() {
    return {
      pages: ['Home', 'About', 'Shop', 'Contacts'],
      posts: {
        'lorem ipsum': '02 feb 2017',
        'lorem ips': '04 apr 2017',
        'lorem i': '12 jun 2017'
      },
      socials: ['twitter', 'facebook', 'youtube', 'instagram']
    };
  },

  methods: {
    changePage: function changePage(page) {
      _router2.default.push({
        name: page,
        params: {
          user: this.user,
          productsInCart: this.productsInCart
        }
      });
    }
  }
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(9);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(19);

var _keys2 = _interopRequireDefault(_keys);

var _router = __webpack_require__(5);

var _router2 = _interopRequireDefault(_router);

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'main-header',
  props: ['user', 'productsInCart'],
  data: function data() {
    return {
      pages: ['Home', 'About', 'Shop', 'Contacts'],
      showMenu: false
    };
  },

  computed: {
    cartShow: function cartShow() {
      return (0, _keys2.default)(this.productsInCart).length > 0;
    }
  },
  methods: {
    changePage: function changePage(page) {
      _router2.default.push({
        name: page,
        params: {
          user: this.user,
          productsInCart: this.productsInCart
        }
      });
    },
    cartAmount: function cartAmount() {
      return (0, _values2.default)(this.productsInCart).reduce(function (sum, product) {
        return sum + Number(product.price);
      }, 0);
    },
    removeFromCart: function removeFromCart(key) {
      _firebase2.default.dbUsersRef.child(this.user.uid + '/cart/' + key).remove();
      this.$delete(this.productsInCart, key);
    }
  }
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'notification',
  props: ['message']
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

var _Notification = __webpack_require__(26);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'profile',
  props: ['user', 'light'],
  components: {
    Notification: _Notification2.default
  },
  data: function data() {
    return {
      options: [{
        name: 'My Profile',
        action: this.showModal
      }, {
        name: 'Settings',
        action: this.showModal
      }, {
        name: 'Log out',
        action: this.logOut
      }],
      modal: false,
      name: '',
      uid: '',
      email: '',
      password: '',
      photoUrl: '',
      avatar: '',
      lockInfo: true,
      lockPassword: true,
      checkPassword: false,
      reAuthAction: null,
      message: ''
    };
  },
  created: function created() {
    this.name = this.user.displayName || this.user.email.split('@')[0];
    this.email = this.user.email;
    this.uid = this.user.uid;
    this.photoUrl = this.user.photoURL || __webpack_require__(15);
  },

  methods: {
    logOut: function logOut() {
      _firebase2.default.auth.signOut();
    },
    showModal: function showModal() {
      this.modal = true;
    },
    closeModal: function closeModal() {
      this.modal = false;
      this.lockInfo = true;
      this.lockPassword = true;
      this.checkPassword = false;
      this.reAuthAction = null;
      this.message = '';
    },
    uploadPhoto: function uploadPhoto(event) {
      var _this = this;

      var file = event.target.files[0];
      if (file.size / 1024 > 2048) {
        this.message = 'Your image is too big. Maximal file size is 2MB.';
        return;
      }
      this.avatar = this.uid;
      var storageFileRef = _firebase2.default.storageAvatarsRef.child(this.avatar);
      var task = storageFileRef.put(file);
      task.on('state_changed', function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        _this.message = 'Upload is ' + Math.round(progress) + '% done';
      }, function (error) {
        switch (error.code) {
          case 'storage/unauthorized':
            _this.message = 'Sorry, but you don\'t have permission to upload files';
            break;
          case 'storage/canceled':
            _this.message = 'You canceled the upload';
            break;
          default:
            _this.message = error.code;
        }
      }, function () {
        storageFileRef.getDownloadURL().then(function (url) {
          _this.photoUrl = url;
          _this.changePhoto();
        });
        _this.message = 'Upload is complete!';
      });
    },
    deletePhoto: function deletePhoto() {
      if (this.avatar) {
        _firebase2.default.storageAvatarsRef.child('avatars/' + this.avatar).delete();
      }
    },
    changePhoto: function changePhoto() {
      this.user.updateProfile({
        photoURL: this.photoUrl
      });
    },
    changeInfo: function changeInfo() {
      if (this.lockInfo) {
        this.lockInfo = false;
        return;
      }
      this.user.updateProfile({
        displayName: this.name
      });
      this.user.updateEmail(this.email);
      this.lockInfo = true;
    },
    activatePassword: function activatePassword() {
      if (this.lockPassword) {
        this.changePassword();
        return;
      }
      this.updatePassword();
    },
    changePassword: function changePassword() {
      this.reAuthAction = 'change';
      this.checkPassword = true;
      this.message = 'Please confirm your password';
    },
    updatePassword: function updatePassword() {
      var _this2 = this;

      this.user.updatePassword(this.password).then(function () {
        _this2.message = 'Your password was updated!';
      });
    },
    deleteUser: function deleteUser() {
      this.reAuthAction = 'delete';
      this.checkPassword = true;
      this.message = 'Please confirm your password';
    },
    reAuth: function reAuth() {
      var _this3 = this;

      var credential = _firebase2.default.emailAuth.credential(this.user.email, this.password);
      this.user.reauthenticate(credential).then(function () {
        if (_this3.reAuthAction === 'delete') {
          _this3.user.delete().then(function () {
            _this3.message = 'You have just been erased';
            _this3.deletePhoto();
          });
        } else if (_this3.reAuthAction === 'change') {
          _this3.lockPassword = false;
          _this3.checkPassword = false;
          _this3.message = 'Please enter new password';
        }
      });
    }
  }
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'about',
  firebase: {
    products: _firebase2.default.dbProductsRef
  },
  data: function data() {
    return {
      socials: ['twitter', 'facebook', 'youtube', 'instagram']
    };
  }
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(9);

var _values2 = _interopRequireDefault(_values);

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'cart',
  props: ['user', 'productsInCart'],
  data: function data() {
    return {};
  },

  methods: {
    cartAmount: function cartAmount() {
      return (0, _values2.default)(this.productsInCart).reduce(function (sum, product) {
        return sum + Number(product.price);
      }, 0);
    },
    removeFromCart: function removeFromCart(key) {
      _firebase2.default.dbUsersRef.child(this.user.uid + '/cart/' + key).remove();
      this.$delete(this.productsInCart, key);
    }
  }
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'checkout',
  props: ['user'],
  data: function data() {
    return {
      billing: {
        firstName: '',
        secondName: '',
        country: '',
        address: '',
        city: '',
        zip: ''
      },
      shipping: {
        firstName: '',
        secondName: '',
        country: '',
        address: '',
        city: '',
        zip: ''
      },
      email: '',
      phone: ''
    };
  },

  methods: {
    remAddress: function remAddress() {
      _firebase2.default.dbUsersRef.child(this.user.uid + '/address').set(this.billing);
    },
    completeShipping: function completeShipping() {
      this.shipping = this.billing;
    }
  }
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'contacts',
  firebase: {
    products: _firebase2.default.dbProductsRef
  },
  data: function data() {
    return {
      socials: ['twitter', 'facebook', 'youtube', 'instagram']
    };
  }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'index',
  firebase: {
    products: _firebase2.default.dbProductsRef
  },
  data: function data() {
    return {
      activeSlide: 0,
      slides: [{
        name: 'main',
        title: 'Welcome to our media market place!',
        text: 'Stock on photos, illustrations and videos from best creatives\
        around the world'
      }, {
        name: 'team',
        title: 'Join our creative team!',
        text: 'Stock on photos, illustrations and videos from best creatives\
        around the world'
      }, {
        name: 'shop',
        title: 'Welcome to our media market place!',
        text: 'Stock on photos, illustrations and videos from best creatives\
        around the world'
      }],
      topProducts: {}
    };
  },

  computed: {
    sortTopProducts: function sortTopProducts() {
      this.topProducts = this.products.sort(function (prodA, prodB) {
        return prodA.stars <= prodB.stars ? 1 : -1;
      }).slice(0, 3);
      return this.topProducts.length >= 1;
    }
  },
  methods: {
    changeSlide: function changeSlide(n) {
      if (n === 'prev') {
        this.activeSlide !== 0 ? this.activeSlide -= 1 : this.activeSlide = 2;
      } else if (n === 'next') {
        this.activeSlide !== 2 ? this.activeSlide += 1 : this.activeSlide = 0;
      } else {
        this.activeSlide = n;
      }
    },
    loadImage: function loadImage(slide) {
      if (slide === 'main') {
        return __webpack_require__(110);
      } else if (slide === 'team') {
        return __webpack_require__(109);
      }
      return __webpack_require__(108);
    }
  }
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'product',
  props: ['productModal', 'topProducts'],
  data: function data() {
    return {
      socials: ['twitter', 'facebook', 'youtube', 'instagram']
    };
  },

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(19);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(9);

var _values2 = _interopRequireDefault(_values);

var _router = __webpack_require__(5);

var _router2 = _interopRequireDefault(_router);

var _firebase = __webpack_require__(1);

var _firebase2 = _interopRequireDefault(_firebase);

var _Product = __webpack_require__(120);

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'shop',
  firebase: {
    products: _firebase2.default.dbProductsRef
  },
  props: ['user', 'productsInCart'],
  components: {
    Product: _Product2.default
  },
  data: function data() {
    return {
      selectedCategory: 'all',
      selectedSort: 'none',
      categories: ['all', 'illustrations', 'patterns', 'photos'],
      sorts: ['none', 'newest', 'popular'],
      productModal: null,
      filteredProducts: {},
      productsOnPage: 0,
      activePage: 1,
      productsStars: {},
      starBoxHover: false
    };
  },
  created: function created() {
    var _this = this;

    this.filteredProducts = this.products;
    this.$firebaseRefs.products.on('value', function (snapshot) {
      snapshot.forEach(function (productSnap) {
        var key = productSnap.key;
        var value = productSnap.val();
        if (productSnap.val().rating) {
          _this.$set(_this.productsStars, key, (0, _values2.default)(value.rating).reduce(function (sum, val) {
            return sum + val;
          }, 0));
        } else {
          _this.$set(_this.productsStars, key, 0);
        }
      });
    });
    this.productsOnPage = document.documentElement.clientWidth < 480 ? 8 : 12;
  },

  computed: {
    cartShow: function cartShow() {
      return (0, _keys2.default)(this.productsInCart).length > 0;
    },
    topProducts: function topProducts() {
      return this.sortByRating(this.products).slice(0, 3);
    }
  },
  methods: {
    changePage: function changePage(page) {
      _router2.default.push({
        name: page,
        params: {
          user: this.user,
          productsInCart: this.productsInCart
        }
      });
    },
    changeGalleryPage: function changeGalleryPage(galleryPage) {
      this.activePage = galleryPage;
      window.scrollTo(0, 0);
    },
    showProductModal: function showProductModal(product) {
      this.productModal = product;
    },
    closeProductModal: function closeProductModal() {
      this.productModal = null;
    },
    sortByRating: function sortByRating(products) {
      return this.deepClone(products).sort(function (prodA, prodB) {
        if (prodA.rating && prodB.rating) {
          var ratingA = (0, _values2.default)(prodA.rating).reduce(function (sum, val) {
            return sum + val;
          }, 0);
          var ratingB = (0, _values2.default)(prodB.rating).reduce(function (sum, val) {
            return sum + val;
          }, 0);
          return ratingA <= ratingB ? 1 : -1;
        }
        return prodB.rating ? 1 : -1;
      });
    },
    rateProduct: function rateProduct(product, stars) {
      var updates = {};
      updates['/products/' + product['.key'] + '/rating/' + this.user.uid] = stars;
      _firebase2.default.dbRef.update(updates);
    },
    addToCart: function addToCart(product) {
      _firebase2.default.dbUsersRef.child(this.user.uid + '/cart/' + product['.key']).set({
        name: product.name,
        price: product.price,
        url: product.url
      });
    },
    checkInCart: function checkInCart(product) {
      if (product) {
        return this.productsInCart[product['.key']] !== undefined;
      }
      return false;
    },
    cartAmount: function cartAmount() {
      return (0, _values2.default)(this.productsInCart).reduce(function (sum, product) {
        return sum + Number(product.price);
      }, 0);
    },
    removeFromCart: function removeFromCart(key) {
      _firebase2.default.dbUsersRef.child(this.user.uid + '/cart/' + key).remove();
      this.$delete(this.productsInCart, key);
    },
    getStars: function getStars(product) {
      return this.productsStars[product['.key']];
    },
    deepClone: function deepClone(obj) {
      return JSON.parse((0, _stringify2.default)(obj));
    }
  },
  watch: {
    selectedCategory: function selectedCategory(newCategory) {
      if (newCategory === 'all') {
        this.filteredProducts = this.products;
        return;
      }
      this.filteredProducts = this.deepClone(this.products).filter(function (prod) {
        return prod.type === newCategory;
      });
      this.activePage = 1;
    },
    selectedSort: function selectedSort(newSort) {
      switch (newSort) {
        case 'popular':
          this.filteredProducts = this.sortByRating(this.products);
          break;
        case 'newest':
          this.filteredProducts = this.deepClone(this.products).sort(function (prodA, prodB) {
            return Date.parse(prodA.date) < Date.parse(prodB.date) ? 1 : -1;
          });
          break;
        default:
          this.filteredProducts = this.products;
      }
      this.activePage = 1;
    }
  }
};

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzY2NiI+PHBhdGggZD0iTTE5LDRIMTUuNUwxNC41LDNIOS41TDguNSw0SDVWNkgxOU02LDE5QTIsMiAwIDAsMCA4LDIxSDE2QTIsMiAwIDAsMCAxOCwxOVY3SDZWMTlaIiAvPjwvc3ZnPgo="

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiM2NjYiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLDE2QTIsMiAwIDAsMSAxNCwxOEEyLDIgMCAwLDEgMTIsMjBBMiwyIDAgMCwxIDEwLDE4QTIsMiAwIDAsMSAxMiwxNk0xMiwxMEEyLDIgMCAwLDEgMTQsMTJBMiwyIDAgMCwxIDEyLDE0QTIsMiAwIDAsMSAxMCwxMkEyLDIgMCAwLDEgMTIsMTBNMTIsNEEyLDIgMCAwLDEgMTQsNkEyLDIgMCAwLDEgMTIsOEEyLDIgMCAwLDEgMTAsNkEyLDIgMCAwLDEgMTIsNFoiIC8+PC9zdmc+Cg=="

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjIwcHgiIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDIwIDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4wLjMgKDc4OTEpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPnBvc3QtZmFjZWJvb2s8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4KICAgICAgICA8ZyBpZD0iSWNvbnMtU29jaWFsIiBza2V0Y2g6dHlwZT0iTVNMYXllckdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4wMDAwMDAsIC0xNjkuMDAwMDAwKSIgZmlsbD0iIzY2NiI+CiAgICAgICAgICAgIDxnIGlkPSJwb3N0LWZhY2Vib29rIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMTY5LjAwMDAwMCkiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE4LDAgTDIsMCBDMC45LDAgMCwwLjkgMCwyIEwwLDE4IEMwLDE5LjEgMC45LDIwIDIsMjAgTDE4LDIwIEMxOS4xLDIwIDIwLDE5LjEgMjAsMTggTDIwLDIgQzIwLDAuOSAxOS4xLDAgMTgsMCBMMTgsMCBaIE0xNywyIEwxNyw1IEwxNSw1IEMxNC40LDUgMTQsNS40IDE0LDYgTDE0LDggTDE3LDggTDE3LDExIEwxNCwxMSBMMTQsMTggTDExLDE4IEwxMSwxMSBMOSwxMSBMOSw4IEwxMSw4IEwxMSw1LjUgQzExLDMuNiAxMi42LDIgMTQuNSwyIEwxNywyIEwxNywyIFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiM2NjYiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTcuOCwySDE2LjJDMTkuNCwyIDIyLDQuNiAyMiw3LjhWMTYuMkE1LjgsNS44IDAgMCwxIDE2LjIsMjJINy44QzQuNiwyMiAyLDE5LjQgMiwxNi4yVjcuOEE1LjgsNS44IDAgMCwxIDcuOCwyTTcuNiw0QTMuNiwzLjYgMCAwLDAgNCw3LjZWMTYuNEM0LDE4LjM5IDUuNjEsMjAgNy42LDIwSDE2LjRBMy42LDMuNiAwIDAsMCAyMCwxNi40VjcuNkMyMCw1LjYxIDE4LjM5LDQgMTYuNCw0SDcuNk0xNy4yNSw1LjVBMS4yNSwxLjI1IDAgMCwxIDE4LjUsNi43NUExLjI1LDEuMjUgMCAwLDEgMTcuMjUsOEExLjI1LDEuMjUgMCAwLDEgMTYsNi43NUExLjI1LDEuMjUgMCAwLDEgMTcuMjUsNS41TTEyLDdBNSw1IDAgMCwxIDE3LDEyQTUsNSAwIDAsMSAxMiwxN0E1LDUgMCAwLDEgNywxMkE1LDUgMCAwLDEgMTIsN00xMiw5QTMsMyAwIDAsMCA5LDEyQTMsMyAwIDAsMCAxMiwxNUEzLDMgMCAwLDAgMTUsMTJBMywzIDAgMCwwIDEyLDlaIiAvPjwvc3ZnPgo="

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE2cHgiIGhlaWdodD0iMjNweCIgdmlld0JveD0iMCAwIDE2IDIzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4wLjMgKDc4OTEpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmxvY2s8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4KICAgICAgICA8ZyBpZD0iQ29yZSIgc2tldGNoOnR5cGU9Ik1TTGF5ZXJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ2Ni4wMDAwMDAsIC0yOTUuMDAwMDAwKSIgZmlsbD0iIzY2NiI+CiAgICAgICAgICAgIDxnIGlkPSJsb2NrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NjYuMDAwMDAwLCAyOTUuNTAwMDAwKSIgc2tldGNoOnR5cGU9Ik1TU2hhcGVHcm91cCI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTQsNyBMMTMsNyBMMTMsNSBDMTMsMi4yIDEwLjgsMCA4LDAgQzUuMiwwIDMsMi4yIDMsNSBMMyw3IEwyLDcgQzAuOSw3IDAsNy45IDAsOSBMMCwxOSBDMCwyMC4xIDAuOSwyMSAyLDIxIEwxNCwyMSBDMTUuMSwyMSAxNiwyMC4xIDE2LDE5IEwxNiw5IEMxNiw3LjkgMTUuMSw3IDE0LDcgTDE0LDcgWiBNOCwxNiBDNi45LDE2IDYsMTUuMSA2LDE0IEM2LDEyLjkgNi45LDEyIDgsMTIgQzkuMSwxMiAxMCwxMi45IDEwLDE0IEMxMCwxNS4xIDkuMSwxNiA4LDE2IEw4LDE2IFogTTExLjEsNyBMNC45LDcgTDQuOSw1IEM0LjksMy4zIDYuMywxLjkgOCwxLjkgQzkuNywxLjkgMTEuMSwzLjMgMTEuMSw1IEwxMS4xLDcgTDExLjEsNyBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjIwcHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDIwIDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4wLjMgKDc4OTEpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPm1haWw8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4KICAgICAgICA8ZyBpZD0iQ29yZSIgc2tldGNoOnR5cGU9Ik1TTGF5ZXJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuMDAwMDAwLCAtMzQwLjAwMDAwMCkiIGZpbGw9IiM2NjYiPgogICAgICAgICAgICA8ZyBpZD0ibWFpbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDM0MC4wMDAwMDApIiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xOCwwIEwyLDAgQzAuOSwwIDAsMC45IDAsMiBMMCwxNCBDMCwxNS4xIDAuOSwxNiAyLDE2IEwxOCwxNiBDMTkuMSwxNiAyMCwxNS4xIDIwLDE0IEwyMCwyIEMyMCwwLjkgMTkuMSwwIDE4LDAgTDE4LDAgWiBNMTgsNCBMMTAsOSBMMiw0IEwyLDIgTDEwLDcgTDE4LDIgTDE4LDQgTDE4LDQgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjIwcHgiIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDIwIDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4wLjMgKDc4OTEpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmFjY291bnQtY2lyY2xlPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9IkNvcmUiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04Ni4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGw9IiM2NjYiPgogICAgICAgICAgICA8ZyBpZD0iYWNjb3VudC1jaXJjbGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg2LjAwMDAwMCwgMi4wMDAwMDApIiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMCwwIEM0LjUsMCAwLDQuNSAwLDEwIEMwLDE1LjUgNC41LDIwIDEwLDIwIEMxNS41LDIwIDIwLDE1LjUgMjAsMTAgQzIwLDQuNSAxNS41LDAgMTAsMCBMMTAsMCBaIE0xMCwzIEMxMS43LDMgMTMsNC4zIDEzLDYgQzEzLDcuNyAxMS43LDkgMTAsOSBDOC4zLDkgNyw3LjcgNyw2IEM3LDQuMyA4LjMsMyAxMCwzIEwxMCwzIFogTTEwLDE3LjIgQzcuNSwxNy4yIDUuMywxNS45IDQsMTQgQzQsMTIgOCwxMC45IDEwLDEwLjkgQzEyLDEwLjkgMTYsMTIgMTYsMTQgQzE0LjcsMTUuOSAxMi41LDE3LjIgMTAsMTcuMiBMMTAsMTcuMiBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjIwcHgiIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDIwIDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4wLjMgKDc4OTEpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPnBvc3QtdHdpdHRlcjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHNrZXRjaDp0eXBlPSJNU1BhZ2UiPgogICAgICAgIDxnIGlkPSJJY29ucy1Tb2NpYWwiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjAwMDAwMCwgLTIxMS4wMDAwMDApIiBmaWxsPSIjNjY2Ij4KICAgICAgICAgICAgPGcgaWQ9InBvc3QtdHdpdHRlciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDIxMS4wMDAwMDApIiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xOCwwIEwyLDAgQzAuOSwwIDAsMC45IDAsMiBMMCwxOCBDMCwxOS4xIDAuOSwyMCAyLDIwIEwxOCwyMCBDMTkuMSwyMCAyMCwxOS4xIDIwLDE4IEwyMCwyIEMyMCwwLjkgMTkuMSwwIDE4LDAgTDE4LDAgWiBNMTUuNyw3LjMgQzE1LjYsMTEuOSAxMi43LDE1LjEgOC4zLDE1LjMgQzYuNSwxNS40IDUuMiwxNC44IDQsMTQuMSBDNS4zLDE0LjMgNywxMy44IDcuOSwxMyBDNi42LDEyLjkgNS44LDEyLjIgNS40LDExLjEgQzUuOCwxMS4yIDYuMiwxMS4xIDYuNSwxMS4xIEM1LjMsMTAuNyA0LjUsMTAgNC40LDguNCBDNC43LDguNiA1LjEsOC43IDUuNSw4LjcgQzQuNiw4LjIgNCw2LjMgNC43LDUuMSBDNiw2LjUgNy42LDcuNyAxMC4yLDcuOSBDOS41LDUuMSAxMy4zLDMuNiAxNC44LDUuNSBDMTUuNSw1LjQgMTYsNS4xIDE2LjUsNC45IEMxNi4zLDUuNiAxNS45LDYgMTUuNCw2LjQgQzE1LjksNi4zIDE2LjQsNi4yIDE2LjgsNiBDMTYuNyw2LjUgMTYuMiw2LjkgMTUuNyw3LjMgTDE1LjcsNy4zIFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiM2NjYiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEwLDE2LjVWNy41TDE2LDEyTTIwLDQuNEMxOS40LDQuMiAxNS43LDQgMTIsNEM4LjMsNCA0LjYsNC4xOSA0LDQuMzhDMi40NCw0LjkgMiw4LjQgMiwxMkMyLDE1LjU5IDIuNDQsMTkuMSA0LDE5LjYxQzQuNiwxOS44MSA4LjMsMjAgMTIsMjBDMTUuNywyMCAxOS40LDE5LjgxIDIwLDE5LjYxQzIxLjU2LDE5LjEgMjIsMTUuNTkgMjIsMTJDMjIsOC40IDIxLjU2LDQuOTEgMjAsNC40WiIgLz48L3N2Zz4K"

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bookblock.82ac5ea.jpg";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/deer.c41cda5.jpg";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yellow-sofa.b6b5b83.jpg";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(82)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  "data-v-4f6f48fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(84)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(130),
  /* scopeId */
  "data-v-61dfd822",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(77)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-1f7b103e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(78)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-2bedd7fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(85)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(131),
  /* scopeId */
  "data-v-7b39b0d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(134),
  /* scopeId */
  "data-v-d9797374",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  "data-v-394b9e6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(79)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  "data-v-2f5362f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(133),
  /* scopeId */
  "data-v-ca1ce8c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(81)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  "data-v-3ab554b9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(132),
  /* scopeId */
  "data-v-7e4acb1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "logo-link",
    on: {
      "click": function($event) {
        _vm.changePage("Home")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(25),
      "alt": "Logo"
    }
  })])]), _c('div', {
    staticClass: "cart"
  }, [_c('a', {
    staticClass: "cart-link"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(24),
      "alt": "Cart"
    }
  }), (_vm.cartShow) ? _c('span', {
    staticClass: "cart-count"
  }) : _vm._e()]), _c('div', {
    staticClass: "cart-submenu"
  }, [_c('ul', {
    staticClass: "cart-list"
  }, _vm._l((_vm.productsInCart), function(product, key) {
    return _c('li', {
      staticClass: "cart-product"
    }, [_c('a', {
      staticClass: "product-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })]), _c('div', {
      staticClass: "product-description"
    }, [_c('a', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(product.name))]), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$ " + _vm._s(product.price))])]), _c('a', {
      staticClass: "product-remove",
      on: {
        "click": function($event) {
          _vm.removeFromCart(key)
        }
      }
    })])
  })), _c('div', {
    staticClass: "cart-subtotal"
  }, [_c('span', [_vm._v("Subtotal")]), _c('span', [_vm._v("$ " + _vm._s(_vm.cartAmount()))])]), _c('div', {
    staticClass: "cart-links"
  }, [_c('a', {
    staticClass: "cart-view",
    on: {
      "click": function($event) {
        _vm.changePage("Cart")
      }
    }
  }, [_vm._v("View Cart")]), _c('a', {
    staticClass: "cart-checkout",
    on: {
      "click": function($event) {
        _vm.changePage("Checkout")
      }
    }
  }, [_vm._v("Checkout")])])])]), _c('a', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        _vm.showMenu = !_vm.showMenu
      }
    }
  }, [_c('div', {
    staticClass: "toggle-icon",
    class: {
      open: _vm.showMenu
    }
  }, [_c('span'), _c('span'), _c('span')]), _c('transition', {
    attrs: {
      "name": "toggle-menu"
    }
  }, [(_vm.showMenu) ? _c('nav', {
    staticClass: "nav"
  }, _vm._l((_vm.pages), function(page) {
    return _c('a', {
      staticClass: "nav-link",
      on: {
        "click": function($event) {
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  })) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('a', {
    staticClass: "profile-name",
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(_vm._s(_vm.name))]), _c('a', {
    staticClass: "profile-img"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.photoUrl,
      "alt": "Avatar"
    }
  })]), _c('ul', {
    staticClass: "profile-dropdown"
  }, _vm._l((_vm.options), function(option) {
    return _c('li', {
      staticClass: "dropdown-item"
    }, [_c('a', {
      on: {
        "click": option.action
      }
    }, [_vm._v(_vm._s(option.name))])])
  }))]), (_vm.modal) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.closeModal
    }
  }) : _vm._e(), (_vm.modal) ? _c('a', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeModal
    }
  }) : _vm._e(), (_vm.modal && !_vm.checkPassword) ? _c('form', {
    staticClass: "modal"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "profile-photo"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.photoUrl,
      "alt": "Avatar"
    }
  })]), _c('input', {
    staticClass: "modal-upload",
    attrs: {
      "name": "photo",
      "id": "photo",
      "type": "file"
    },
    on: {
      "change": _vm.uploadPhoto
    }
  }), _c('label', {
    staticClass: "modal-action",
    attrs: {
      "for": "photo"
    }
  }, [_vm._v("Choose")]), _c('a', {
    staticClass: "delete-action",
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("Delete account")])]), _c('div', {
    staticClass: "profile-info"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-face"
  }), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "blur": function($event) {
        _vm.lockInfo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }, 'input', {
    placeholder: (_vm.lockInfo ? _vm.name : "New name..."),
    readonly: _vm.lockInfo
  }))]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-mail"
  }), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": function($event) {
        _vm.lockInfo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }, 'input', {
    placeholder: (_vm.lockInfo ? _vm.email : "New email..."),
    readonly: _vm.lockInfo
  }))]), _c('a', {
    staticClass: "modal-action",
    class: {
      "action-update": !_vm.lockInfo
    },
    on: {
      "click": _vm.changeInfo
    }
  }, [_vm._v(_vm._s(_vm.lockInfo ? 'Change...' : 'Update'))]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-lock"
  }), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": function($event) {
        _vm.lockPassword = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }, 'input', {
    placeholder: (_vm.lockPassword ? "Password" : "New password..."),
    readonly: _vm.lockPassword
  }))]), _c('a', {
    staticClass: "modal-action",
    class: {
      "action-update": !_vm.lockPassword
    },
    on: {
      "click": _vm.activatePassword
    }
  }, [_vm._v(_vm._s(_vm.lockPassword ? 'Change...' : 'Update'))])])])]) : _vm._e(), (_vm.checkPassword) ? _c('div', {
    staticClass: "modal modal-confirm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('a', {
    staticClass: "modal-action action-update",
    on: {
      "click": _vm.reAuth
    }
  }, [_vm._v("Confirm")])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "note"
    }
  }, [(_vm.message.length > 0) ? _c('notification', {
    attrs: {
      "message": _vm.message
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = ""
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-head"
  }, [_c('a', {
    staticClass: "modal-title"
  }, [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-head modal-subhead"
  }, [_c('a', {
    staticClass: "modal-title"
  })])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Hi there! We're an awesome group of creatives from a variety of\ndifferent backgrounds with a variety of skills.")]), _c('section', {
    staticClass: "email"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("CONTACT US")]), _vm._m(0), _c('div', {
    staticClass: "contact"
  }, [_c('p', {
    staticClass: "contact-address"
  }, [_vm._v("9000456,")]), _c('p', {
    staticClass: "contact-address"
  }, [_vm._v("2426 Sing Street,")]), _c('p', {
    staticClass: "contact-address"
  }, [_vm._v("Quesnel BC,")]), _c('p', {
    staticClass: "contact-address"
  }, [_vm._v("V2J 4P7, Canada.")]), _c('ul', {
    staticClass: "social-list"
  }, _vm._l((_vm.socials), function(social) {
    return _c('li', {
      staticClass: "social-item"
    }, [_c('a', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(17)("./" + social + ".svg")
      }
    })])])
  }))])]), _c('section', {
    staticClass: "map"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("FIND US")]), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2403.    423905567938!2d-122.44442138383793!3d52.95878827989962!2m3!1f0!2f0!3f0!3m    2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53870578f27359f5%3A0xf834004e0cdb5bf2!2    zU2luZyBTdCwgUXVlc25lbCwgQkMsINCa0LDQvdCw0LTQsA!5e0!3m2!1sru!2sru!4v14887    93347529",
      "width": "100%",
      "height": "450",
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "email-form"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "First Name...",
      "name": "firstName"
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Second Name...",
      "name": "secondName"
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "email",
      "placeholder": "Email...",
      "name": "email"
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Company...",
      "name": "company"
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Text...",
      "name": "text"
    }
  })]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Submit")])])
}]}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Finalize Your Order")]), _c('section', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('form', {
    staticClass: "order-form"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v(" Billing")]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.firstName),
      expression: "billing.firstName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "First Name...",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.billing.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.firstName = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.secondName),
      expression: "billing.secondName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Second Name...",
      "name": "secondName"
    },
    domProps: {
      "value": (_vm.billing.secondName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.secondName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "email",
      "placeholder": "Email...",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.phone),
      expression: "phone",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Phone...",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.country),
      expression: "billing.country"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Country...",
      "name": "country"
    },
    domProps: {
      "value": (_vm.billing.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.country = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.address),
      expression: "billing.address"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Billing Address",
      "name": "address"
    },
    domProps: {
      "value": (_vm.billing.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.city),
      expression: "billing.city"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "City...",
      "name": "city"
    },
    domProps: {
      "value": (_vm.billing.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.city = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.billing.zip),
      expression: "billing.zip",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Zip...",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.billing.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.zip = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-checkbox"
  }, [_c('input', {
    staticClass: "input-check",
    attrs: {
      "type": "checkbox",
      "id": "address"
    },
    on: {
      "click": _vm.remAddress
    }
  }), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Remember address?")])]), _c('div', {
    staticClass: "input-checkbox"
  }, [_c('input', {
    staticClass: "input-check",
    attrs: {
      "type": "checkbox",
      "id": "shipping"
    },
    on: {
      "click": _vm.completeShipping
    }
  }), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "shipping"
    }
  }, [_vm._v("Same shipping address?")])])])]), _c('form', {
    staticClass: "order-form"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v(" Shipping")]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.firstName),
      expression: "shipping.firstName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "First Name...",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.shipping.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.firstName = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.secondName),
      expression: "shipping.secondName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Second Name...",
      "name": "secondName"
    },
    domProps: {
      "value": (_vm.shipping.secondName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.secondName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.country),
      expression: "shipping.country"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Country...",
      "name": "country"
    },
    domProps: {
      "value": (_vm.shipping.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.country = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address),
      expression: "shipping.address"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Shipping Address",
      "name": "address"
    },
    domProps: {
      "value": (_vm.shipping.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.city),
      expression: "shipping.city"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "City...",
      "name": "city"
    },
    domProps: {
      "value": (_vm.shipping.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.city = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.shipping.zip),
      expression: "shipping.zip",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Zip...",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.shipping.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.zip = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "widget-payment"
  }, [_c('h2', {
    staticClass: "widget-title"
  }, [_vm._v("Payment Options")]), _c('div', {
    staticClass: "payment-option"
  }, [_c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])]), _c('form', {
    staticClass: "payment-data"
  }, [_c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Owner Name..."
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Account Number..."
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Date..."
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "CVV Code..."
    }
  })])]), _c('div', {
    staticClass: "payment-total"
  }, [_c('h2', [_vm._v("Cart Total")]), _c('div', {
    staticClass: "subtotal-line"
  }, [_c('p', [_vm._v("Subtotal")]), _c('p', [_vm._v("$15")])]), _c('div', {
    staticClass: "total-line"
  }, [_c('p', [_vm._v("Total")]), _c('p', [_vm._v("$15")])]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Place Your Order")])])])
}]}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-modal"
  }, [_c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.close
    }
  }), _c('a', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }), _c('section', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.productModal.url
    }
  })]), _c('div', {
    staticClass: "modal-content"
  }, [_c('h2', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.productModal.name))]), _c('h4', {
    staticClass: "product-author"
  }, [_vm._v(_vm._s(_vm.productModal.author))]), _c('div', {
    staticClass: "product-info"
  }, [_c('span', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm.productModal.price))])]), _vm._m(0), _c('div', {
    staticClass: "product-cart"
  }, [_c('a', {
    staticClass: "input-btn"
  }, [_vm._v("Add to Card")]), _c('ul', {
    staticClass: "product-social"
  }, _vm._l((_vm.socials), function(social) {
    return _c('li', {
      staticClass: "social-item"
    }, [_c('a', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(17)("./" + social + ".svg")
      }
    })])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-about"
  }, [_c('p', {
    staticClass: "about-text"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do\neiusmod tempor incididunt ut labore et dolore magna aliqua.\nUt enim ad minim veniam, quis nostrud exercitation ullamco\nlaboris nisi ut aliquip ex ea commodo consequat.")])])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_c('div', {
    staticClass: "login-sign"
  }, [_c('a', {
    staticClass: "sign-btn",
    on: {
      "click": function($event) {
        _vm.login = "in"
      }
    }
  }, [_vm._v("Sign In")]), _c('a', {
    staticClass: "sign-btn",
    on: {
      "click": function($event) {
        _vm.login = "up"
      }
    }
  }, [_vm._v("Sign Up")])]), (_vm.login) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.login = false
      }
    }
  }) : _vm._e(), (_vm.login) ? _c('a', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.login = false
      }
    }
  }) : _vm._e(), (_vm.login) ? _c('form', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-head"
  }, [_c('h4', {
    staticClass: "social-title"
  }, [_vm._v(_vm._s(_vm.login === 'in' ? 'Sign In' : 'Sign Up'))]), _c('div', {
    staticClass: "social-img"
  }, [_c('a', {
    staticClass: "social-link social-google",
    on: {
      "click": _vm.signInGoogle
    }
  }), _c('a', {
    staticClass: "social-link social-twitter"
  }), _c('a', {
    staticClass: "social-link social-facebook"
  })])]), _c('p', {
    staticClass: "modal-title"
  }, [_vm._v("or Be Classical")]), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-mail"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email..."
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-lock"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password..."
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('a', {
    staticClass: "modal-action",
    on: {
      "click": _vm.enter
    }
  }, [_vm._v(_vm._s(_vm.login === 'in' ? 'Enter' : 'Get Started'))])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "note"
    }
  }, [(_vm.message.length > 0) ? _c('notification', {
    attrs: {
      "message": _vm.message
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = ""
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('main-header', _vm._b({}, 'main-header', {
    user: _vm.user,
    productsInCart: _vm.productsInCart
  })), _c('router-view'), _c('main-footer', _vm._b({}, 'main-footer', {
    user: _vm.user,
    productsInCart: _vm.productsInCart
  })), (!_vm.user) ? _c('login', {
    on: {
      "signInGoogle": _vm.getUserGoogle
    }
  }) : _vm._e(), (_vm.user) ? _c('profile', _vm._b({}, 'profile', {
    user: _vm.user
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note"
  }, [_c('p', {
    staticClass: "note-message"
  }, [_vm._v(_vm._s(_vm.message))]), _c('a', {
    staticClass: "close-btn"
  })])
},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _c('div', {
    staticClass: "nav"
  }, [_c('h4', [_vm._v("Menu")]), _vm._l((_vm.pages), function(page) {
    return _c('ul', {
      staticClass: "list"
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])])
  })], 2), _c('div', {
    staticClass: "blog"
  }, [_c('h4', [_vm._v("Recent posts")]), _vm._l((_vm.posts), function(val, key) {
    return _c('ul', {
      staticClass: "list"
    }, [_c('li', {
      staticClass: "post"
    }, [_c('a', [_vm._v(_vm._s(key))]), _c('div', {
      staticClass: "post-data"
    }, [_vm._v(_vm._s(val))])])])
  })], 2), _c('div', {
    staticClass: "contact"
  }, [_c('h4', [_vm._v("Contact us")]), _c('p', [_vm._v("2426 Sing Street,")]), _c('p', [_vm._v("Quesnel BC,")]), _c('p', [_vm._v("V2J 4P7, Canada.")]), _c('ul', {
    staticClass: "list social-list"
  }, _vm._l((_vm.socials), function(social) {
    return _c('li', {
      staticClass: "social-item"
    }, [_c('a', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(17)("./" + social + ".svg")
      }
    })])])
  }))])]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(25)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v("Developed by pxlhead. All rights reserved. ®")])])
}]}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Hi there! We're an awesome group of creatives from a variety of different\nbackgrounds with a variety of skills.")]), _c('section', {
    staticClass: "team"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("TEAM")]), _vm._l((_vm.products), function(product, index) {
    return (index < 8) ? _c('div', {
      staticClass: "gallery-product"
    }, [_c('h2', {
      staticClass: "person-name"
    }, [_vm._v("Ipsum Lorem")]), _c('span', {
      staticClass: "person-prof"
    }, [_vm._v("Ipsum Lorem")]), _c('p', {
      staticClass: "person-description"
    }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do\neiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })])]) : _vm._e()
  })], 2), _c('section', {
    staticClass: "awards"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("AWARDS")]), _vm._l((4), function(n) {
    return _c('div', {
      staticClass: "awards-item"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(16),
        "alt": "Awwwwards"
      }
    })])
  })], 2), _c('section', {
    staticClass: "clients"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("CLIENTS")]), _vm._l((2), function(n) {
    return _c('div', {
      staticClass: "clients-row"
    }, _vm._l((4), function(n) {
      return _c('div', {
        staticClass: "clients-item"
      }, [_c('img', {
        attrs: {
          "src": __webpack_require__(16),
          "alt": "Awwwwards"
        }
      })])
    }))
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Welcome to our creative store - we sell uncommon design\nillustrations that smack you right in the heart.")]), _c('section', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "gallery"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategory),
      expression: "selectedCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category
      }
    }, [_vm._v("Category: " + _vm._s(category))])
  })), _c('span', {
    staticClass: "select-arrow"
  })]), _c('div', {
    staticClass: "select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSort),
      expression: "selectedSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sorts), function(sort) {
    return _c('option', {
      domProps: {
        "value": sort
      }
    }, [_vm._v("Sort by: " + _vm._s(sort))])
  })), _c('span', {
    staticClass: "select-arrow"
  })])]), _c('transition-group', {
    staticClass: "gallery-row",
    attrs: {
      "name": "gallery-anim",
      "tag": "div",
      "mode": "out-in"
    }
  }, _vm._l((_vm.filteredProducts), function(product, index) {
    return (index >= _vm.productsOnPage * (_vm.activePage - 1) && index < _vm.productsOnPage * _vm.activePage) ? _c('div', {
      key: index,
      staticClass: "gallery-product"
    }, [_c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      },
      on: {
        "click": function($event) {
          _vm.showProductModal(product)
        }
      }
    }), _c('div', {
      staticClass: "product-actions",
      class: {
        "product-actions--active": _vm.starBoxHover
      }
    }, [_c('a', {
      staticClass: "cart-link",
      class: {
        "cart-link--active": _vm.checkInCart(product)
      },
      on: {
        "click": function($event) {
          _vm.addToCart(product)
        }
      }
    }), _c('div', {
      staticClass: "star-box",
      on: {
        "mouseenter": function($event) {
          _vm.starBoxHover = true
        },
        "mouseleave": function($event) {
          _vm.starBoxHover = false
        }
      }
    }, _vm._l((5), function(star) {
      return _c('span', {
        staticClass: "star star-link",
        on: {
          "click": function($event) {
            _vm.rateProduct(product, (6 - star))
          }
        }
      })
    }))])]), _c('h2', {
      staticClass: "product-title",
      on: {
        "click": function($event) {
          _vm.showProductModal(product)
        }
      }
    }, [_vm._v(_vm._s(product.name))]), _c('span', {
      staticClass: "product-author"
    }, [_vm._v(_vm._s(product.author))]), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$" + _vm._s(product.price) + ".00")])]) : _vm._e()
  }))], 1), _c('aside', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "widget-top"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Top Rated")]), _c('ul', {
    staticClass: "top-list"
  }, _vm._l((_vm.topProducts), function(product) {
    return _c('li', {
      staticClass: "top-product"
    }, [_c('div', {
      staticClass: "top-product-info"
    }, [_c('a', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(product.name))]), _c('div', {
      staticClass: "product-stars"
    }, _vm._l((5), function(n) {
      return _c('span', {
        staticClass: "star",
        class: {
          "star-full": n <= _vm.getStars(product)
        }
      })
    })), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$" + _vm._s(product.price) + ".00")])]), _c('div', {
      staticClass: "top-product-img"
    }, [_c('img', {
      staticClass: "product-img",
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })])])
  }))]), (_vm.cartShow) ? _c('div', {
    staticClass: "widget-cart"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Cart Review")]), _c('ul', {
    staticClass: "cart-list"
  }, _vm._l((_vm.productsInCart), function(product, key) {
    return _c('li', {
      staticClass: "cart-product"
    }, [_c('a', {
      staticClass: "product-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })]), _c('div', {
      staticClass: "product-description"
    }, [_c('a', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(product.name))]), _c('span', {
      staticClass: "product-price"
    }, [_vm._v("$ " + _vm._s(product.price))])]), _c('a', {
      staticClass: "product-remove",
      on: {
        "click": function($event) {
          _vm.removeFromCart(key)
        }
      }
    })])
  })), _c('div', {
    staticClass: "cart-subtotal"
  }, [_c('span', [_vm._v("Subtotal")]), _c('span', [_vm._v("$ " + _vm._s(_vm.cartAmount()))])]), _c('div', {
    staticClass: "cart-links"
  }, [_c('a', {
    staticClass: "cart-view",
    on: {
      "click": function($event) {
        _vm.changePage("Cart")
      }
    }
  }, [_vm._v("View Cart")]), _c('a', {
    staticClass: "cart-checkout",
    on: {
      "click": function($event) {
        _vm.changePage("Checkout")
      }
    }
  }, [_vm._v("Checkout")])])]) : _vm._e(), _vm._m(0)])]), _c('nav', {
    staticClass: "pagination"
  }, [_c('a', {
    staticClass: "nav-prev",
    class: {
      "nav-disable": _vm.activePage == 1
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.activePage - 1)
      }
    }
  }, [_vm._v("Prev Page")]), _c('div', {
    staticClass: "nav-pages"
  }, _vm._l((Math.ceil(_vm.filteredProducts.length / _vm.productsOnPage)), function(n) {
    return _c('a', {
      staticClass: "page-num",
      class: {
        "page-active": n == _vm.activePage
      },
      on: {
        "click": function($event) {
          _vm.changeGalleryPage(n)
        }
      }
    }, [_vm._v(_vm._s(n))])
  })), _c('a', {
    staticClass: "nav-next",
    class: {
      "nav-disable": _vm.activePage == Math.ceil(_vm.filteredProducts.length / _vm.productsOnPage)
    },
    on: {
      "click": function($event) {
        _vm.changeGalleryPage(_vm.activePage + 1)
      }
    }
  }, [_vm._v("Next Page")])]), (_vm.productModal) ? _c('product', _vm._b({
    on: {
      "close": _vm.closeProductModal
    }
  }, 'product', {
    productModal: _vm.productModal,
    topProducts: _vm.topProducts
  })) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-payment"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Payment Options")]), _c('p', {
    staticClass: "payment-details"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed\ndo eiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _c('div', {
    staticClass: "payment-option"
  }, [_c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])])])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider"
  }, [_vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      staticClass: "slide",
      class: {
        "slide-active": index == _vm.activeSlide
      }
    }, [_c('div', {
      staticClass: "slide-content"
    }, [_c('h1', {
      staticClass: "slide-title"
    }, [_vm._v(_vm._s(slide.title))]), _c('h4', {
      staticClass: "slide-text"
    }, [_vm._v(_vm._s(slide.text))]), _vm._m(0, true)]), _c('div', {
      staticClass: "slide-overlay"
    }), _c('figure', {
      staticClass: "slide-img"
    }, [_c('img', _vm._b({
      attrs: {
        "alt": "Welcome picture"
      }
    }, 'img', {
      src: _vm.loadImage(slide.name),
      class: [("img-" + (slide.name))]
    }))])])
  }), _c('nav', {
    staticClass: "slider-nav"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('a', {
      staticClass: "nav-point",
      class: {
        "point-active": index == _vm.activeSlide
      },
      on: {
        "click": function($event) {
          _vm.changeSlide(index)
        }
      }
    })
  })), _c('a', {
    staticClass: "nav-arrow arrow-prev",
    on: {
      "click": function($event) {
        _vm.changeSlide("prev")
      }
    }
  }), _c('a', {
    staticClass: "nav-arrow arrow-next",
    on: {
      "click": function($event) {
        _vm.changeSlide("next")
      }
    }
  })], 2), _c('section', {
    staticClass: "about"
  }, [_vm._m(1), _c('div', {
    staticClass: "about-video"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": "https://goo.gl/aieVs4"
    }
  })], 1)]), _vm._m(2), _c('section', {
    staticClass: "awards"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("AWARDS")]), _vm._l((4), function(n) {
    return _c('div', {
      staticClass: "awards-item"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(16),
        "alt": "Awwwwards"
      }
    })])
  })], 2), (_vm.sortTopProducts) ? _c('section', {
    staticClass: "gallery"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("GALLERY")]), _vm._l((_vm.topProducts), function(product) {
    return _c('div', {
      staticClass: "gallery-product"
    }, [_c('figure', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    }), _c('div', {
      staticClass: "img-overlay"
    }, [_c('h2', {
      staticClass: "overlay-title"
    }, [_vm._v(_vm._s(product.name))]), _c('p', {
      staticClass: "overlay-author"
    }, [_vm._v(_vm._s(product.author))])])])])
  })], 2) : _vm._e(), _c('section', {
    staticClass: "comments"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("COMMENTS")]), _vm._l((4), function(n) {
    return _c('div', {
      staticClass: "comment"
    }, [_vm._m(3, true), _c('cite', {
      staticClass: "comment-author"
    }, [_vm._v("Alex, Google")]), _c('blockquote', {
      staticClass: "comment-text"
    }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.")])], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-action"
  }, [_c('a', [_vm._v("Read more")]), _c('a', [_vm._v("See works")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-item"
  }, [_c('h2', {
    staticClass: "about-title"
  }, [_vm._v("PXLSHOP is a platform for handcrafted, mousemade design content\nfrom independent creatives around the world.")]), _c('p', {
    staticClass: "about-text"
  }, [_vm._v("Pxlshop, a global technology company, has created a great two-sided\nmarketplace for creative professionals to license content - including\nimages, videos and music - as well as innovative tools that power the\ncreative process.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "info"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("INFO")]), _c('div', {
    staticClass: "info-item"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("We kind to our authors")]), _c('p', [_vm._v("Artists are at the heart of everything we do and the reason why\npxlshop continues to be an important destination for stock content.\nBy providing a platform for our artists to distribute some of the best\nstock content in the world, we give them the opportunity to\ntransform their lives by making a living through their art.")])]), _c('div', {
    staticClass: "info-item"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("We kind to our culture")]), _c('p', [_vm._v("We are where art starts, but that's only the beginning. We are the\nmovement for the liberation of creative expression. We believe that\nart is for everyone, and we're creating the cultural context for how\nit is created, discovered, and shared.")])]), _c('div', {
    staticClass: "info-item"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("We kind to our clients")]), _c('p', [_vm._v("Registration is free and gives you access to browse thousands of\nprofessional royalty-free stock photos, illustrations and patterns.\nFind great files from the world’s top contributors at the lowest\nprices. We always welcome to customize all our plans to suit your needs.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "comment-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(15),
      "alt": "Author avatar"
    }
  })])
}]}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Review Your Cart")]), _c('section', {
    staticClass: "basket"
  }, [_c('div', {
    staticClass: "cart"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("Your cart")]), _c('div', {
    staticClass: "cart-table"
  }, [_vm._m(0), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('figure', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })])
  }), _vm._m(1), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('div', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_vm._v(_vm._s(product.name))])
  }), _vm._m(2), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('div', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_vm._v("$ " + _vm._s(product.price))])
  }), _vm._m(3), _vm._l((_vm.productsInCart), function(product, key, index) {
    return _c('div', {
      staticClass: "table-cell",
      style: ({
        order: (index + 2)
      })
    }, [_c('a', {
      staticClass: "product-remove",
      on: {
        "click": function($event) {
          _vm.removeFromCart(key)
        }
      }
    })])
  })], 2), _vm._m(4)]), _c('div', {
    staticClass: "payment"
  }, [_vm._m(5), _c('div', {
    staticClass: "payment-total"
  }, [_c('h2', [_vm._v("Cart Total")]), _c('div', {
    staticClass: "subtotal-line"
  }, [_c('p', [_vm._v("Subtotal")]), _c('p', [_vm._v("$" + _vm._s(_vm.cartAmount()))])]), _c('div', {
    staticClass: "total-line"
  }, [_c('p', [_vm._v("Total")]), _c('p', [_vm._v("$" + _vm._s(_vm.cartAmount()))])]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Proceed to Checkout")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("PRODUCT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("NAME")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("PRICE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-cell",
    staticStyle: {
      "order": "1"
    }
  }, [_c('h3', [_vm._v("REMOVE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-footer"
  }, [_c('input', {
    staticClass: "cart-coupon",
    attrs: {
      "type": "text",
      "placeholder": "Put you code here..."
    }
  }), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Apply")]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Renew Cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-payment"
  }, [_c('h3', {
    staticClass: "widget-title"
  }, [_vm._v("Payment Options")]), _c('p', {
    staticClass: "payment-details"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed\ndo eiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _c('div', {
    staticClass: "payment-option"
  }, [_c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6)
    }
  })])])])
}]}

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(27);

__webpack_require__(28);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _vuefire = __webpack_require__(30);

var _vuefire2 = _interopRequireDefault(_vuefire);

var _App = __webpack_require__(29);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(5);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuefire2.default);

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ })
],[137]);


// WEBPACK FOOTER //
// static/js/app.a3adb1b817d8104d87ca.js